import 'bootstrap-daterangepicker/daterangepicker.css';
import 'bootstrap/dist/css/bootstrap.css';
import classnames from 'classnames';
import { format, startOfDay } from 'date-fns';
import { orderBy } from 'lodash';
import moment from 'moment';
import Pagination from 'rc-pagination';
import 'rc-pagination/assets/index.css';
import React, { Component } from 'react';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import {
  Button,
  ButtonGroup,
  Col,
  Container,
  Input,
  Nav,
  Row,
  TabContent,
  TabPane,
} from 'reactstrap';
import * as CallsActions from '../actions/Calls';
import { setActiveCallsTab } from '../actions/Calls';
import * as CompanyActions from '../actions/Companies';
import { cancelDeleteUser, showDeleteUser } from '../actions/Users';
import Breadcrumbs from '../components/Breadcrumb';
import IncomingCallsList from '../components/Calls/IncomingCallsList';
import OutgoingCallsList from '../components/Calls/OutgoingCallsList';
import CompanyAutocomplete from '../components/CompanyAutocomplete';
import DeleteModal from '../components/DeleteModal';
import DropdownSelect from '../components/ProposalGenerator/DropdownSelect';
import SetLimitEntries from '../components/SetLimitEntries';
import WithUserData from '../HOC/withUserData';
import { ENG_LOCALE } from '../lib/constants';
import Calendar from '../Res/Icon/Calendar.png';
import Company from '../Res/Icon/Company.png';
import NumberList from '../Res/Icon/Number-list.png';
import './calls.css';

const dropdownOptionsOut = [
  { label: 'Called Number', value: 'calledNum' },
  { label: 'Calling Number', value: 'callingNum' },
  { label: 'Origination CID', value: 'outgoingCid' },
];
const dropdownOptionsIn = [
  { label: 'Called Number', value: 'calledNum' },
  { label: 'Calling Number', value: 'callingNum' },
  { label: 'Forwarded To', value: 'fwdNum' },
];

class Calls extends Component {
  constructor(props) {
    super(props);
    this.token = localStorage.getItem('jwtToken');
    this.state = {
      sortOut: {
        name: '',
        order: '',
      },
      sortIn: {
        name: '',
        order: '',
      },
      date: [startOfDay(new Date()), moment().subtract(6, 'days')._d],
      outFilter: '',
      inFilter: '',
      selectStatusOut: dropdownOptionsOut[0],
      selectStatusIn: dropdownOptionsIn[0],
      sort: {
        name: '',
        order: '',
      },
    };

    this.ranges = {
      Today: [moment(), moment()],
      Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
      'Last 7 Days': [moment().subtract(6, 'days'), moment()],
      'Last 30 Days': [moment().subtract(29, 'days'), moment()],
      'This Month': [moment().startOf('month'), moment().endOf('month')],
      'Last Month': [
        moment()
          .subtract(1, 'month')
          .startOf('month'),
        moment()
          .subtract(1, 'month')
          .endOf('month'),
      ],
    };
  }

  componentDidMount = async () => {
    const {
      user,
      setOutCallsFilterByCompany,
      setInCallsFilterByCompany,
      outgoingCallsFilterCompany,
      incomingCallsFilterCompany,
      setOutCallsFilter,
      setInCallsFilter,
    } = this.props;

    if (
      user.role === 'superAdmin' ||
      user.role === 'supportEngineer' ||
      user.role === 'companyGroupAdmin' ||
      user.role === 'companyGroupManager'
    ) {
      // await getCompanies(this.token, user.company._id, 'yes');
      await setOutCallsFilterByCompany(
        this.token,
        outgoingCallsFilterCompany.value ? outgoingCallsFilterCompany.suggestion._id : null,
        { page: 1, limit: 10 },
        this.state.date,
      );
      await setInCallsFilterByCompany(
        this.token,
        incomingCallsFilterCompany.value ? incomingCallsFilterCompany.suggestion._id : null,
        { page: 1, limit: 10 },
        this.state.date,
      );
      // await setInCallsFilterSerch(this.token, filter, { page: 1, limit: 10 }, date, cid);
    } else {
      await setOutCallsFilterByCompany(
        this.token,
        user.company._id,
        { page: 1, limit: 10 },
        this.state.date,
      );
      await setInCallsFilterByCompany(
        this.token,
        user.company._id,
        { page: 1, limit: 10 },
        this.state.date,
      );
      let filter = {
        value: user.company.name,
        suggestion: {
          _id: user.company._id,
        },
      };
      setOutCallsFilter(filter);
      setInCallsFilter(filter);
    }
  };

  handleSetLimit = async limit => {
    const {
      activeCallsTab,
      outgoingCallsFilterCompany,
      incomingCallsFilterCompany,
      setOutCallsFilterByCompany,
      setInCallsFilterByCompany,
      setOutCallsFilterSerch,
      setInCallsFilterSerch,
    } = this.props;
    const { outFilter, inFilter, selectStatusOut, selectStatusIn } = this.state;

    if (activeCallsTab === 'outgoing') {
      if (outgoingCallsFilterCompany) {
        const cid = outgoingCallsFilterCompany.value
          ? outgoingCallsFilterCompany.suggestion._id
          : null;
        if (outFilter === '') {
          await setOutCallsFilterByCompany(
            this.token,
            cid,
            {
              page: 1,
              limit,
            },
            this.state.date,
          );
        } else {
          let filter = { name: selectStatusOut.value, value: outFilter };
          await setOutCallsFilterSerch(
            this.token,
            filter,
            { page: 1, limit },
            this.state.date,
            cid,
          );
        }
      } else {
        let cid = null;
        let filter = { name: selectStatusOut.value, value: outFilter };
        await setOutCallsFilterSerch(this.token, filter, { page: 1, limit }, this.state.date, cid);
      }
    } else {
      if (incomingCallsFilterCompany) {
        const cid = incomingCallsFilterCompany.value
          ? incomingCallsFilterCompany.suggestion._id
          : null;
        if (inFilter === '') {
          await setInCallsFilterByCompany(
            this.token,
            cid,
            {
              page: 1,
              limit,
            },
            this.state.date,
          );
        } else {
          let filter = { name: selectStatusIn.value, value: inFilter };
          await setInCallsFilterSerch(this.token, filter, { page: 1, limit }, this.state.date, cid);
        }
      } else {
        let cid = null;
        let filter = { name: selectStatusIn.value, value: inFilter };
        await setInCallsFilterSerch(this.token, filter, { page: 1, limit }, this.state.date, cid);
      }
    }
  };

  handleChangePagination = async numPage => {
    const {
      calls,
      activeCallsTab,
      outgoingCallsFilterCompany,
      incomingCallsFilterCompany,
      setOutCallsFilterByCompany,
      setInCallsFilterByCompany,
      setOutCallsFilterSerch,
      setInCallsFilterSerch,
    } = this.props;
    const { outFilter, inFilter, selectStatusOut, selectStatusIn } = this.state;

    if (activeCallsTab === 'outgoing') {
      if (outgoingCallsFilterCompany) {
        const cid = outgoingCallsFilterCompany.value
          ? outgoingCallsFilterCompany.suggestion._id
          : null;
        if (outFilter === '') {
          await setOutCallsFilterByCompany(
            this.token,
            cid,
            {
              page: numPage,
              limit: calls.outgoingCalls.limit,
            },
            this.state.date,
          );
        } else {
          let filter = { name: selectStatusOut.value, value: outFilter };
          await setOutCallsFilterSerch(
            this.token,
            filter,
            { page: numPage, limit: calls.outgoingCalls.limit },
            this.state.date,
            cid,
          );
        }
      } else {
        let cid = null;
        let filter = { name: selectStatusOut.value, value: outFilter };
        await setOutCallsFilterSerch(
          this.token,
          filter,
          { page: numPage, limit: calls.outgoingCalls.limit },
          this.state.date,
          cid,
        );
      }
    } else {
      if (incomingCallsFilterCompany) {
        const cid = incomingCallsFilterCompany.value
          ? incomingCallsFilterCompany.suggestion._id
          : null;
        if (inFilter === '') {
          await setInCallsFilterByCompany(
            this.token,
            cid,
            {
              page: numPage,
              limit: calls.incomingCalls.limit,
            },
            this.state.date,
          );
        } else {
          let filter = { name: selectStatusIn.value, value: inFilter };
          await setInCallsFilterSerch(
            this.token,
            filter,
            { page: numPage, limit: calls.incomingCalls.limit },
            this.state.date,
            cid,
          );
        }
      } else {
        let cid = null;
        let filter = { name: selectStatusIn.value, value: inFilter };
        await setInCallsFilterSerch(
          this.token,
          filter,
          { page: numPage, limit: calls.incomingCalls.limit },
          this.state.date,
          cid,
        );
      }
    }
  };

  onCallsFilterByCompany = async called => {
    const {
      setOutCallsFilter,
      setInCallsFilter,
      setOutCallsFilterByCompany,
      setInCallsFilterByCompany,
      calls,
      setOutCallsFilterSerch,
      setInCallsFilterSerch,
    } = this.props;
    const { selectStatusOut, selectStatusIn, outFilter, inFilter } = this.state;

    setOutCallsFilter(called || {});
    if (!called || !called.value) {
      setOutCallsFilter({});
      if (outFilter === '') {
        await setOutCallsFilterByCompany(
          this.token,
          null,
          {
            page: 1,
            limit: calls.outgoingCalls.limit,
          },
          this.state.date,
        );
      } else {
        let cid = null;
        let filter = { name: selectStatusOut.value, value: outFilter };
        await setOutCallsFilterSerch(
          this.token,
          filter,
          { page: 1, limit: calls.outgoingCalls.limit },
          this.state.date,
          cid,
        );
      }
    } else {
      if (outFilter === '') {
        await setOutCallsFilterByCompany(
          this.token,
          called.suggestion._id,
          {
            page: 1,
            limit: calls.outgoingCalls.limit,
          },
          this.state.date,
        );
      } else {
        let cid = called.suggestion._id;
        let filter = { name: selectStatusOut.value, value: outFilter };
        await setOutCallsFilterSerch(
          this.token,
          filter,
          { page: 1, limit: calls.outgoingCalls.limit },
          this.state.date,
          cid,
        );
      }
    }
    setInCallsFilter(called || {});
    if (!called || !called.value) {
      setInCallsFilter({});
      if (inFilter === '') {
        await setInCallsFilterByCompany(
          this.token,
          null,
          {
            page: 1,
            limit: calls.incomingCalls.limit,
          },
          this.state.date,
        );
      } else {
        let cid = null;
        let filter = { name: selectStatusIn.value, value: inFilter };
        await setInCallsFilterSerch(
          this.token,
          filter,
          { page: 1, limit: calls.incomingCalls.limit },
          this.state.date,
          cid,
        );
      }
    } else {
      if (outFilter === '') {
        await setInCallsFilterByCompany(
          this.token,
          called.suggestion._id,
          {
            page: 1,
            limit: calls.incomingCalls.limit,
          },
          this.state.date,
        );
      } else {
        let cid = called.suggestion._id;
        let filter = { name: selectStatusOut.value, value: outFilter };
        await setInCallsFilterSerch(
          this.token,
          filter,
          { page: 1, limit: calls.incomingCalls.limit },
          this.state.date,
          cid,
        );
      }
    }
  };

  sortColumnByKey = array => {
    const { sortOut, sortIn } = this.state;
    const { activeCallsTab } = this.props;
    const sort = activeCallsTab === 'outgoing' ? sortOut : sortIn;

    if (sort.name.indexOf('[') !== -1) {
      const sortNameArr = sort.name.replace(/[\[\]']+/g, ' ').split(' ');
      return orderBy(array, [el => el[sortNameArr[0]][sortNameArr[1]].toLowerCase()], [sort.order]);
    }
    if (typeof array[0][sort.name] === 'string') {
      return orderBy(array, [el => el[sort.name].toLowerCase()], [sort.order]);
    }
    return orderBy(array, [el => el[sort.name]], [sort.order]);
  };

  handleSortDate = filter => {
    const { sortOut, sortIn } = this.state;
    const { activeCallsTab } = this.props;
    const updateSort = activeCallsTab === 'outgoing' ? { ...sortOut } : { ...sortIn };

    if (updateSort.name === filter) {
      updateSort.order = updateSort.order === 'asc' ? 'desc' : 'asc';
    } else {
      updateSort.name = filter;
      updateSort.order = 'asc';
    }
    if (activeCallsTab === 'outgoing') {
      this.setState({ sortOut: updateSort });
    } else {
      this.setState({ sortIn: updateSort });
    }
  };

  changeCalledNumber = async e => {
    const {
      activeCallsTab,
      setOutCallsFilterSerch,
      setInCallsFilterSerch,
      calls,
      outgoingCallsFilterCompany,
      incomingCallsFilterCompany,
    } = this.props;
    const { value, name } = e.currentTarget;
    const { selectStatusOut, selectStatusIn } = this.state;
    this.setState({ [name]: value.trim() });
    if (activeCallsTab === 'outgoing') {
      this.setState({ outFilter: value });
      if (outgoingCallsFilterCompany) {
        const cid = outgoingCallsFilterCompany.value
          ? outgoingCallsFilterCompany.suggestion._id
          : null;
        let filter = { name: selectStatusOut.value, value: value };
        await setOutCallsFilterSerch(
          this.token,
          filter,
          { page: 1, limit: calls.outgoingCalls.limit },
          this.state.date,
          cid,
        );
      } else {
        let cid = null;
        let filter = { name: this.state.selectStatusOut.value, value: value };
        await setOutCallsFilterSerch(
          this.token,
          filter,
          { page: 1, limit: calls.outgoingCalls.limit },
          this.state.date,
          cid,
        );
      }
    } else {
      this.setState({ inFilter: value });
      if (incomingCallsFilterCompany) {
        const cid = incomingCallsFilterCompany.value
          ? incomingCallsFilterCompany.suggestion._id
          : null;
        let filter = { name: selectStatusIn.value, value: value };
        await setInCallsFilterSerch(
          this.token,
          filter,
          { page: 1, limit: calls.incomingCalls.limit },
          this.state.date,
          cid,
        );
      } else {
        let cid = null;
        let filter = { name: this.state.selectStatusIn.value, value: value };
        await setInCallsFilterSerch(
          this.token,
          filter,
          { page: 1, limit: calls.outgoingCalls.limit },
          this.state.date,
          cid,
        );
      }
    }
  };

  onStatusSortSelect = selectedOption => {
    const { activeCallsTab } = this.props;
    if (activeCallsTab === 'outgoing') {
      this.setState({ selectStatusOut: selectedOption });
    } else {
      this.setState({ selectStatusIn: selectedOption });
    }
  };

  filterByValue = (arr, filter) => {
    const { activeCallsTab } = this.props;
    return arr.filter(el => {
      if (activeCallsTab === 'outgoing') {
        const { value } = this.state.selectStatusOut;
        return el[value] && el[value].includes(filter);
      }
      const { value } = this.state.selectStatusIn;
      return el[value] && el[value].includes(filter);
    });
  };

  handeleClick = e => {
    const el = document.querySelector('.daterangepicker');
    el.classList.toggle('show-dp');
  };

  onApply = (e, piker) => {
    const dataEnd = piker.endDate._d;
    const dataStart = piker.startDate._d;

    this.setState({ date: [dataEnd, dataStart] }, async () => {
      const {
        calls,
        outgoingCallsFilterCompany,
        incomingCallsFilterCompany,
        setOutCallsFilterByCompany,
        setInCallsFilterByCompany,
        setOutCallsFilterSerch,
        setInCallsFilterSerch,
      } = this.props;
      const { selectStatusOut, selectStatusIn, outFilter, inFilter } = this.state;

      // if (activeCallsTab === 'outgoing') {
      if (Object.keys(outgoingCallsFilterCompany).length) {
        const cid = outgoingCallsFilterCompany.value
          ? outgoingCallsFilterCompany.suggestion._id
          : null;
        if (outFilter === '') {
          await setOutCallsFilterByCompany(
            this.token,
            cid,
            {
              page: calls.outgoingCalls.page,
              limit: calls.outgoingCalls.limit,
            },
            this.state.date,
          );
        } else {
          let filter = { name: selectStatusOut.value, value: outFilter };
          await setOutCallsFilterSerch(
            this.token,
            filter,
            { page: calls.outgoingCalls.page, limit: calls.outgoingCalls.limit },
            this.state.date,
            cid,
          );
        }
      } else {
        let cid = null;
        let filter = { name: selectStatusOut.value, value: outFilter };
        await setOutCallsFilterSerch(
          this.token,
          filter,
          { page: calls.outgoingCalls.page, limit: calls.outgoingCalls.limit },
          this.state.date,
          cid,
        );
      }
      // } else {
      if (Object.keys(incomingCallsFilterCompany).length) {
        const cid = incomingCallsFilterCompany.value
          ? incomingCallsFilterCompany.suggestion._id
          : null;
        if (inFilter === '') {
          await setInCallsFilterByCompany(
            this.token,
            cid,
            {
              page: calls.incomingCalls.page,
              limit: calls.incomingCalls.limit,
            },
            this.state.date,
          );
        } else {
          let filter = { name: selectStatusIn.value, value: inFilter };
          await setInCallsFilterSerch(
            this.token,
            filter,
            { page: calls.incomingCalls.page, limit: calls.incomingCalls.limit },
            this.state.date,
            cid,
          );
        }
      } else {
        let cid = null;
        let filter = { name: selectStatusIn.value, value: inFilter };
        await setInCallsFilterSerch(
          this.token,
          filter,
          { page: calls.incomingCalls.page, limit: calls.incomingCalls.limit },
          this.state.date,
          cid,
        );
      }
    });
  };

  handleCDR = () => {
    const { activeCallsTab, outgoingCallRecords, incomingCallRecords } = this.props;
    if (activeCallsTab === 'outgoing') {
      outgoingCallRecords(this.token, this.state.date);
    } else {
      incomingCallRecords(this.token, this.state.date);
    }
  };

  onDelete = async e => {
    const {
      activeCallsTab,
      calls,
      deleteOutgoingCall,
      deleteIncomingCall,
      outgoingCallsFilterCompany,
      incomingCallsFilterCompany,
      setOutCallsFilterByCompany,
      setOutCallsFilterSerch,
      setInCallsFilterByCompany,
      setInCallsFilterSerch,
    } = this.props;
    const { selectStatusOut, selectStatusIn, outFilter, inFilter } = this.state;
    if (activeCallsTab === 'outgoing') {
      const res = await deleteOutgoingCall(this.token, this.state.deleteCallId);
      if (res) {
        if (outgoingCallsFilterCompany) {
          const cid = outgoingCallsFilterCompany.value
            ? outgoingCallsFilterCompany.suggestion._id
            : null;
          if (outFilter === '') {
            await setOutCallsFilterByCompany(
              this.token,
              cid,
              {
                page: calls.outgoingCalls.page,
                limit: calls.outgoingCalls.limit,
              },
              this.state.date,
            );
          } else {
            let filter = { name: selectStatusOut.value, value: outFilter };
            await setOutCallsFilterSerch(
              this.token,
              filter,
              { page: calls.outgoingCalls.page, limit: calls.outgoingCalls.limit },
              this.state.date,
              cid,
            );
          }
        } else {
          let cid = null;
          let filter = { name: selectStatusOut.value, value: outFilter };
          await setOutCallsFilterSerch(
            this.token,
            filter,
            { page: calls.outgoingCalls.page, limit: calls.outgoingCalls.limit },
            this.state.date,
            cid,
          );
        }
      }
    } else {
      const res = await deleteIncomingCall(this.token, this.state.deleteCallId);
      if (res) {
        if (incomingCallsFilterCompany) {
          const cid = incomingCallsFilterCompany.value
            ? incomingCallsFilterCompany.suggestion._id
            : null;
          if (inFilter === '') {
            await setInCallsFilterByCompany(
              this.token,
              cid,
              {
                page: calls.incomingCalls.page,
                limit: calls.incomingCalls.limit,
              },
              this.state.date,
            );
          } else {
            let filter = { name: selectStatusIn.value, value: inFilter };
            await setInCallsFilterSerch(
              this.token,
              filter,
              { page: calls.incomingCalls.page, limit: calls.incomingCalls.limit },
              this.state.date,
              cid,
            );
          }
        } else {
          let cid = null;
          let filter = { name: selectStatusIn.value, value: inFilter };
          await setInCallsFilterSerch(
            this.token,
            filter,
            { page: calls.incomingCalls.page, limit: calls.incomingCalls.limit },
            this.state.date,
            cid,
          );
        }
      }
    }
  };

  onRecoverOutgoing = async e => {
    var res = await this.props.onRecoverOutgoingCall(this.token, e);
    if (res) {
      this.props.getOutgoingCallsByDate(this.token, this.state.date);
    }
  };

  onRecoverIncoming = async e => {
    var res = await this.props.onRecoverIncomingCall(this.token, e);
    if (res) {
      this.props.getIncomingCallsByDate(this.token, this.state.date);
    }
  };
  handleSortCall = filter => {
    const { sort } = this.state;
    const updateSort = { ...sort };

    if (updateSort.name === filter) {
      updateSort.order = updateSort.order === 'asc' ? 'desc' : 'asc';
    } else {
      updateSort.name = filter;
      updateSort.order = 'asc';
    }
    this.setState({ sort: updateSort });
  };
  render() {
    const {
      activeCallsTab,
      setActiveCallsTab,
      calls,
      user,
      companies,
      outgoingCallsFilterCompany,
      incomingCallsFilterCompany,
      deleteMode,
    } = this.props;
    const {
      sortOut,
      sortIn,
      outFilter,
      inFilter,
      selectStatusOut,
      selectStatusIn,
      date,
      sort,
    } = this.state;

    let renderListOutgoing =
      sortOut.name.length && calls.outgoingCalls.docs.length
        ? calls.outgoingCalls?.docs?.length && this.sortColumnByKey(calls.outgoingCalls.docs)
        : calls.outgoingCalls.docs;
    let renderListIncoming =
      sortIn.name.length && calls.incomingCalls.docs.length
        ? calls.incomingCalls?.docs?.length && this.sortColumnByKey(calls.incomingCalls.docs)
        : calls.incomingCalls.docs;
    if (!user || !user._id) {
      return <Redirect to="/login" />;
    }
    return (
      <div>
        <div className="filter-section" style={{ marginBottom: '20px' }}>
          <Row className="row align-items-center" style={{ justifyContent: 'space-between' }}>
            {/* <div lg="2" style={{ display: 'flex' }}>
              <Breadcrumbs />
            </div> */}
            <div
              className="d-flex justify-content-end"
              lg="12"
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                justifyContent: 'flex-end',
                padding: '0 15px',
                textAlign: 'right'
              }}
            >
              {(user.role === 'superAdmin' ||
                user.role === 'supportEngineer' ||
                user.role === 'companyGroupAdmin' ||
                user.role === 'companyGroupManager' ||
                user.role === 'admin' ||
                user.role === 'enterpriseAdmin') && (
                  <Col
                    md={{ size: user.role === 'admin' || user.role === 'enterpriseAdmin' ? 7 : 5 }}
                    className="select-status calls-page-select"
                    style={{ padding: '0', borderRadius: '0', marginRight: '1rem' }}
                  >
                    <div className="calls-page-select-cont" style={{ width: '10rem' }}>
                      {/* <FontAwesomeIcon icon="list-alt" style={{ color: '#FF2437' }} className="analytic-filter-icon" /> */}
                      <img style={{ height: '22px' }} src={NumberList} alt="..."></img>
                    </div>
                    <DropdownSelect
                      options={activeCallsTab === 'outgoing' ? dropdownOptionsOut : dropdownOptionsIn}
                      selectedOption={
                        activeCallsTab === 'outgoing' ? selectStatusOut : selectStatusIn
                      }
                      onSelect={this.onStatusSortSelect}
                    />
                    <Input
                      name={activeCallsTab === 'outgoing' ? 'outFilter' : 'inFilter'}
                      placeholder="Filter number"
                      value={activeCallsTab === 'outgoing' ? outFilter : inFilter}
                      onChange={this.changeCalledNumber}
                    />
                  </Col>
                )}

              {(user.role === 'superAdmin' ||
                user.role === 'supportEngineer' ||
                user.role === 'companyGroupAdmin' ||
                user.role === 'companyGroupManager') &&
                companies.docs ? (
                <Col
                  className="filter-container calls-page-select"
                  style={{ marginRight: '1rem', display: 'flex' }}
                  md="2.5"
                >
                  <div className="calls-page-select-cont">
                    <img style={{ height: '22px' }} src={Company} alt="..."></img>
                    {/* <FontAwesomeIcon icon="list-alt" style={{ color: '#FF2437' }} className="analytic-filter-icon" /> */}
                  </div>
                  <CompanyAutocomplete
                    searchTerm={
                      activeCallsTab === 'outgoing'
                        ? outgoingCallsFilterCompany.value || ''
                        : incomingCallsFilterCompany.value || ''
                    }
                    placeholder="Filter Company..."
                    companies={companies.docs}
                    onChange={this.onCallsFilterByCompany}
                  />
                </Col>
              ) : null}
              {date[0] && date[1] && (
                <Col md={{ size: 3.5 }} className="float-right">
                  <DateRangePicker
                    autoUpdateInput
                    startDate={date[1]}
                    endDate={date[0]}
                    onApply={this.onApply}
                    showCustomRangeLabel
                    alwaysShowCalendars
                    ranges={this.ranges}
                    opens="left"
                    onHide={this.handeleClick}
                    onShow={this.handeleClick}
                  >
                    <div className="input-group" style={{ alignItems: 'center' }}>
                      <span className="input-group-btn">
                        <Button
                          className="default date-range-toggle"
                          style={{
                            background: '#DDE6FA',
                            border: 'none',
                            color: '#FF2437',
                            width: '4rem',
                          }}
                        >
                          <img style={{ height: '22px' }} src={Calendar} alt="..."></img>
                          {/* <FontAwesomeIcon icon="calendar-alt" className="analytic-filter-icon" /> */}
                        </Button>
                      </span>
                      <div className="view-data-input">
                        {format(date[1], 'MM/dd/yyyy')} - {format(date[0], 'MM/dd/yyyy')}
                      </div>
                    </div>
                  </DateRangePicker>
                </Col>
              )}
              {/* <Col md={{ size: user.role === 'admin' ? 7 : 4 }} sm='12' className="select-limit"> */}
              {/* <Col md='2'  className="select-limit">
                <SetLimitEntries
                  value={
                    activeCallsTab === 'outgoing'
                      ? calls.outgoingCalls.limit
                      : calls.incomingCalls.limit
                  }
                  onChange={this.handleSetLimit}
                />
              </Col> */}
            </div>
          </Row>
        </div>
        <Container fluid style={{ margin: '0' }}>
          <div className="calls-page-content viewContainer">
            <Row>
              <Col md={12}>
                <Nav
                  tabs
                  style={{
                    marginBottom: '1rem',
                    border: 'none',
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <ButtonGroup className="tab-group">
                    <Button
                      className={classnames({ active: activeCallsTab === 'outgoing' })}
                      onClick={() => setActiveCallsTab('outgoing')}
                    >
                      Outgoing Calls (
                      {calls.outgoingCalls.docs ? calls.outgoingCalls.totalDocs : '0'})
                    </Button>
                    <Button
                      className={classnames({ active: activeCallsTab === 'incoming' })}
                      onClick={() => setActiveCallsTab('incoming')}
                    >
                      Incoming Calls (
                      {calls.incomingCalls.docs ? calls.incomingCalls.totalDocs : '0'})
                    </Button>
                  </ButtonGroup>
                  {/* <NavItem>
                  <NavLink
                    active={activeCallsTab === 'outgoing'}
                    disabled={activeCallsTab === 'outgoing'}
                    onClick={() => setActiveCallsTab('outgoing')}
                  >
                    <h5 style={{ color: '#7a7a7a' }}>
                      <FontAwesomeIcon icon="sign-in-alt" rotation={180} />
                      {}
                      {' '}
                      Outgoing Calls (
{calls.outgoingCalls.docs ? calls.outgoingCalls.totalDocs : '0'})
                  </h5>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    active={activeCallsTab === 'incoming'}
                    disabled={activeCallsTab === 'incoming'}
                    onClick={() => setActiveCallsTab('incoming')}
                  >
                    <h5 style={{ color: '#7a7a7a' }}>
                      <FontAwesomeIcon icon="sign-in-alt" rotation={180} />
                      {}
                      {' '}
                      Incoming Calls (
{calls.incomingCalls.docs ? calls.incomingCalls.totalDocs : '0'})
                  </h5>
                  </NavLink>
                </NavItem> */}
                </Nav>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <TabContent activeTab={activeCallsTab}>
                  <TabPane tabId="outgoing">
                    <Row>
                      <Col md={12}>
                        {calls.outgoingCalls.docs && (
                          <OutgoingCallsList
                            onRecover={this.onRecoverOutgoing}
                            deleteMode={deleteMode}
                            calls={renderListOutgoing}
                            onSort={this.handleSortDate}
                            sortValue={sortOut}
                            onDelete={e => {
                              this.setState({ deleteCallId: e });
                              this.props.showDeleteUser(e);
                            }}
                            user={this.props.user}
                          />
                        )}
                      </Col>
                    </Row>

                    {calls.outgoingCalls.totalPages > 1 && (
                      <Row className="justify-content-md-center">
                        <SetLimitEntries
                          value={
                            activeCallsTab === 'outgoing'
                              ? calls.outgoingCalls.limit
                              : calls.incomingCalls.limit
                          }
                          onChange={this.handleSetLimit}
                        />
                        <Pagination
                          locale={ENG_LOCALE}
                          className="pagination-container"
                          onChange={this.handleChangePagination}
                          current={calls.outgoingCalls.page}
                          total={calls.outgoingCalls.totalDocs}
                          pageSize={calls.outgoingCalls.limit}
                          showLessItems
                          showTitle={false}
                          showTotal={(total, range) =>
                            `${range[0]} - ${range[1]} of ${total} items`
                          }
                        />
                      </Row>
                    )}

                    {/* <Row>
                    <Col md={12}>
                      {calls.outgoingCalls.totalPages > 1 && (
                        <Pagination
                          className="pagination-container"
                          onChange={this.handleChangePagination}
                          current={calls.outgoingCalls.page}
                          total={calls.outgoingCalls.totalDocs}
                          pageSize={calls.outgoingCalls.limit}
                          showLessItems
                          showTitle={false}
                        />
                      )}
                    </Col>
                  </Row> */}
                  </TabPane>
                  <TabPane tabId="incoming">
                    <Row>
                      <Col md={12}>
                        {calls.incomingCalls.docs && (
                          <IncomingCallsList
                            onRecover={this.onRecoverIncoming}
                            deleteMode={deleteMode}
                            calls={renderListIncoming}
                            onSort={this.handleSortDate}
                            sortValue={sortIn}
                            onDelete={e => {
                              this.setState({ deleteCallId: e });
                              this.props.showDeleteUser(e);
                            }}
                            user={this.props.user}
                          />
                        )}
                      </Col>
                    </Row>

                    {calls.incomingCalls.totalPages > 1 && (
                      <Row className="justify-content-md-center">
                        <SetLimitEntries
                          value={
                            activeCallsTab === 'outgoing'
                              ? calls.outgoingCalls.limit
                              : calls.incomingCalls.limit
                          }
                          onChange={this.handleSetLimit}
                        />
                        <Pagination
                          locale={ENG_LOCALE}
                          className="pagination-container"
                          onChange={this.handleChangePagination}
                          current={calls.incomingCalls.page}
                          total={calls.incomingCalls.totalDocs}
                          pageSize={calls.incomingCalls.limit}
                          showLessItems
                          showTitle={false}
                          showTotal={(total, range) =>
                            `${range[0]} - ${range[1]} of ${total} items`
                          }
                        />
                      </Row>
                    )}
                  </TabPane>
                </TabContent>
              </Col>
            </Row>
          </div>
          <DeleteModal
            data={'Call'}
            isOpen={this.props.deleteShow}
            onCancel={this.props.cancelDeleteUser}
            onConfirm={this.onDelete}
          />
        </Container>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  deleteShow: state.UIState.users.deleteShow,
  user: state.AppState.user,
  calls: state.AppState.calls,
  activeCallsTab: state.UIState.calls.activeCallsTab,
  outgoingCallsFilterCompany: state.UIState.calls.outgoingCallsFilterCompany,
  incomingCallsFilterCompany: state.UIState.calls.incomingCallsFilterCompany,
  companies: state.AppState.companies,
  deleteMode: state.AppState.deleteMode,
});

const mapDispatchToProps = dispatch => ({
  onRecoverIncomingCall: (token, id) => dispatch(CallsActions.onRecoverIncomingCall(token, id)),
  onRecoverOutgoingCall: (token, id) => dispatch(CallsActions.onRecoverOutgoingCall(token, id)),
  deleteOutgoingCall: (token, id) => dispatch(CallsActions.deleteOutgoingCall(token, id)),
  deleteIncomingCall: (token, id) => dispatch(CallsActions.deleteIncomingCall(token, id)),
  cancelDeleteUser: () => dispatch(cancelDeleteUser()),
  showDeleteUser: id => dispatch(showDeleteUser(id)),
  setActiveCallsTab: tab => dispatch(setActiveCallsTab(tab)),
  getCompanies: (token, pagination, disablePaginate) =>
    dispatch(CompanyActions.getCompanies(token, pagination, disablePaginate)),
  setOutCallsFilter: filter => dispatch(CallsActions.outgoingCallsFilter(filter)),
  setInCallsFilter: filter => dispatch(CallsActions.incomingCallsFilter(filter)),
  setOutCallsFilterByCompany: (token, filter, pagination, date) =>
    dispatch(CallsActions.outgoingCallsByCompany(token, filter, pagination, date)),
  setOutCallsFilterSerch: (token, filter, pagination, date, cid) =>
    dispatch(CallsActions.outgoingCallsByFilter(token, filter, pagination, date, cid)),
  setInCallsFilterByCompany: (token, filter, pagination, date) =>
    dispatch(CallsActions.incomingCallsByCompany(token, filter, pagination, date)),
  setInCallsFilterSerch: (token, filter, pagination, date, cid) =>
    dispatch(CallsActions.incomingCallsByFilter(token, filter, pagination, date, cid)),
  getOutgoingCallsByDate: (token, date) =>
    dispatch(CallsActions.getOutgoingCallsByDate(token, date)),
  getIncomingCallsByDate: (token, date) =>
    dispatch(CallsActions.getIncomingCallsByDate(token, date)),
  outgoingCallRecords: (token, date) => dispatch(CallsActions.outgoingCallRecords(token, date)),
  incomingCallRecords: (token, date) => dispatch(CallsActions.incomingCallRecords(token, date)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WithUserData(Calls));
